export const defaultTableCells = [
  {
    label: 'Order ID',
    sortField: 'order_id',
    display: true,
    width: 120
  },
  {
    label: 'First Name',
    sortField: 'firstname',
    display: true,
    width: 100
  },
  {
    label: 'Last Name',
    sortField: 'lastname',
    display: true,
    width: 100
  },
  {
    label: 'Customer Email',
    sortField: 'email',
    display: true,
    width: 160
  },
  {
    label: 'Created',
    sortField: 'created_at',
    display: true,
    width: 100
  },
  {
    label: 'Last Run',
    sortField: 'last_run',
    display: false,
    width: 100
  },
  {
    label: 'Next Run',
    sortField: 'next_run',
    display: true,
    width: 100
  },
  {
    label: 'Deposit',
    sortField: 'deposit',
    display: false,
    width: 100
  },
  {
    label: 'Interval Price',
    sortField: 'interval_price',
    display: true,
    width: 100
  },
  {
    label: 'Interval (days)',
    sortField: 'billing_interval',
    display: false,
    width: 100
  },
  {
    label: 'Times Billed',
    sortField: 'run_count',
    display: true,
    width: 80
  },
  {
    label: 'Status',
    sortField: 'status',
    display: true,
    width: 100
  },
  {
    label: 'Action',
    display: true,
    width: 80
  },
];

export const depositStatus = {
  active: 'Active',
  canceled: 'Canceled',
  complete: 'Complete',
  payment_failed: 'Payment Failed',
};

